import { render } from "./SurveyPage06.vue?vue&type=template&id=67cd02d0&scoped=true"
const script = {}

import "./SurveyPage06.vue?vue&type=style&index=0&id=67cd02d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cd02d0"]])

export default __exports__